import { render, staticRenderFns } from "./AddonItem.vue?vue&type=template&id=558b752c"
import script from "./AddonItem.vue?vue&type=script&lang=js"
export * from "./AddonItem.vue?vue&type=script&lang=js"
import style0 from "./AddonItem.vue?vue&type=style&index=0&id=558b752c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports